module.exports = function($, T, CDD, CV, LDD, LV, EDD, EV) {
    class TabsGroup {
        constructor() {
            this.init();
            this.bind();
        }

        init() {
            let hash = location.hash;
            if ($(hash).length) {
                let group = $(hash).attr('data-group');
                if ($('[data-group="' + group + '"]').length == 0) {
                    return;
                }
                $('[data-group="' + group + '"]').removeClass('active');
                $(hash).addClass('active');

                let $parent = $(hash).parent('[data-group]');
                if ($parent.length > 0) {
                    let group_parent = $parent.attr('data-group');
                    let id_parent = $parent.attr('id');
                    $('[data-group="' + group_parent + '"]').removeClass('active');
                    $('#' + id_parent).addClass('active');
                }
                $("html, body").animate({scrollTop: $(hash).offset().top}, 200);
                CDD.initCards();
                LDD.initCards();
                EDD.initCards();
            }
        }

        bind() {

            $("a[data-group]").on('click', function (e) {
                let id = $(this).attr('href');
                let group = $(this).attr('data-group');
                $("[data-group=\"" + group + "\"]").removeClass('active');
                $(id).addClass('active');
                T.getOffset();
                CDD.initCards();
                CV.markup_vote();
                LDD.initCards();
                LV.markup_vote();
                EV.markup_vote();
                EDD.initCards();
            });

        }
    }
    new TabsGroup;
}
